import styled from 'styled-components'
import { media } from 'styles/media'

import { ArtDirectionImage, Inner, Outer } from '../HeroHeader'

const Gradient = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 19.33%,
    rgba(0, 0, 0, 0) 75.64%
  );

  ${media.md`
      background: linear-gradient(
        89.95deg,
        rgba(0, 0, 0, 0.4) 19.33%,
        rgba(0, 0, 0, 0) 75.64%
    );
  `}
`

const AboutInner = styled(Inner)`
  justify-content: flex-start;
  padding-top: 48px;
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;

  ${media.md`
    padding-top: 0;
    padding-left: 64px;
    padding-right: 64px;
    justify-content: center;
  `}
`

const LargeTitle = styled.h1`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxl']?.['font-size']?.value};
  font-weight: ${({ theme }) =>
    theme?.['-ds-font-size-xxl']?.['font-weight']?.value};
  line-height: 1.3;
  margin-bottom: 24px;
  text-align: left;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xxxl']?.['font-weight']?.value};
  `}
`

const SmallTitle = styled.h2`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};
  font-weight: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-weight']?.value};
  line-height: 1.3;
  margin-bottom: 24px;
  text-align: left;
  max-width: 600px;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-weight']?.value};
    line-height: 1.4;
`}
`
const mobileHeaderImageSrcset = `
  https://assets.riparide.com/landing_pages/about_us/header/mobile_1x.jpg 1x,
  https://assets.riparide.com/landing_pages/about_us/header/mobile_2x.jpg 2x,
  https://assets.riparide.com/landing_pages/about_us/header/mobile_3x.jpg 3x
`

const desktopHeaderImageSrcset = `
  https://assets.riparide.com/landing_pages/about_us/header/desktop_1x.jpg 1x,
  https://assets.riparide.com/landing_pages/about_us/header/desktop_2x.jpg 2x
`

const Header = () => {
  return (
    <Outer>
      <ArtDirectionImage
        mobileImageSrcset={mobileHeaderImageSrcset}
        desktopImageSrcset={desktopHeaderImageSrcset}
        fallbackSrc="https://assets.riparide.com/landing_pages/about_us/header/desktop_1x.jpg"
        cover
        preload
      />
      <Gradient />
      <AboutInner>
        <LargeTitle>About Riparide</LargeTitle>
        <SmallTitle>
          Riparide inspires you to plan and book short nature escapes through
          Storyteller travel guides.
          <br />
          <br />
          Live fully with Riparide.
        </SmallTitle>
      </AboutInner>
    </Outer>
  )
}

export default Header
